import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  /* border-radius: 10px; */
  background: white;
  color: ${({ theme }) => theme.palette.text.primary};
  overflow-y: auto;
  position: relative;
  height: 100vh;
  /* @media (min-width: 769px) {
    width: 800px;
    height: 500px;
  } */
`;

export const Main = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
`;

export const Sidebar = styled.div`
  width: 400px;
  height: auto;
  background: rgba(214, 214, 214, 0.2);
  display: flex;
  flex-direction: column;
  border-left: ${({ theme }) => `1px solid ${theme.palette.divider}`};
  @media (max-width: 768px) {
    display: none;
  }
`;

export const StepContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  & > h2 {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 50px;
  }
`;

export const StepperActionsBox = styled.div`
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${({ theme }) => theme.palette.primary.main};
  padding: 10px;
`;

export const ItemSidebar = styled.div`
  display: flex;
  flex-direction: column;
  height: 50%;
  & > h3 {
    padding: 10px;
    border-bottom: 1px solid #ccc;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    background: rgba(238, 238, 238, 0.5);
    color: #707070;
  }
  & > article {
    padding: 10px;
    height: 100%;
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    line-height: 13px;
    color: #707070;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 5px;
    }
    &::-webkit-scrollbar-thumb {
      background: #ddd;
    }
    & > ul {
      list-style: none;
    }
  }
`;
